import React from "react";

import StaffProfileUI from "./StaffProfileUI";

export default function ProfessorProfileUI(props) {
   return <StaffProfileUI {...props} mode="professor" />;
}
